<form *ngIf="addonForm && !isViewMode" [formGroup]="addonForm" >
	<div class="modal-header">
		<h4 class="modal-title pull-left" translate>{{title}}</h4>
	</div>
	<div class="modal-body">
		<div class="body-content-section">
			<div class="row-fluid">
				<div class="span12" *ngIf="!showDefect">
					<div class="clearfix" *ngIf="showAddOnTemplate && !freemiumAccess">
                        <div class="option-wrapper">
                            <div class="option-card option-template" [class.active]="addonType === 'template'" (click)='optionSelected("template")'>
                                <div class="icon"><img src="../../images/openfolder.svg"></div>
                                <div class="text"><span translate>template.add-on</span></div>
                            </div>
                            <div class="option-card option-template" [class.active]="addonType === 'blank'" (click)='optionSelected("blank")'>
                                <div class="icon"><span class="blank-icon"><i class="fa fa-plus"></i></span></div>
                                <div class="text"><span translate>blank.add-on</span></div>
                            </div>
                        </div>
					</div>
					<div class="control-group clearfix">
						<label class="control-label required_field" *ngIf="addonType == 'blank'" translate>{{labelName}}</label>
						<div class="controls option-section">
							<input formControlName='optionName' appAutoFocus *ngIf='!freemiumAccess && (addonType == "blank" || !showAddOnTemplate)' type="text" class="control-input input-field option-name" (input) ="checkUniqueName($event,isAddTemplateModal)">
                            <div *ngIf="f.optionName.invalid && (f.optionName.dirty || f.optionName.touched)">
                                    <span *ngIf="f.optionName.errors.required && templatesLoading" class="control-error-message show">
                                        <span translate>{{validationMessage}}</span>
								    </span>
                            </div>
                                    <span *ngIf="uniqueName && f.optionName.valid" class="control-error-message show">
                                            <span translate>template.exists</span>
                                    </span>
                            <div class="search-template-box" *ngIf='addonType != "blank" && showAddOnTemplate'>
                                <ng-container>
                                    <app-search-template [screen]="'option_template'" [addon]="true" [screenLabel]="'Addon templates'"
                                                         [showAddNewTemplate]="showAddNewTemplate" [excludeOptions]="excludeOptions"
                                                         (selectedItem)="templateSelected($event)"></app-search-template>
                                </ng-container>
                            </div>
						</div>
                        <div *ngIf="!freemiumAccess && (addonType == 'blank' || !showAddOnTemplate) && (editOrAddDefectRecommendation || showAddon) && templateType !== 'proposal'">
                            <label class="control-label" translate>Customer.displaying.name</label>
                            <input formControlName='customerOptionName'  type="text" class="control-input input-field">
                            <ng-container *ngIf="editorAddon">
                                <div class="blank-page-section">
                                    <div class="blank-image" (click)="addBlankOption($event)">
                                        <span class="blank-icon"><i class="fa fa-plus"></i></span>
                                    </div>
                                    <div class="image-name">
                                        <span>Blank</span>
                                    </div>
                                </div>
                                <div class="controls top-padding" *ngIf="marketPlaceData.length > 0">
                                    <strong translate>choose.from.marketplace</strong>
                                    <div>
                                        <div class="controls">
                                            <div class="category" *ngFor="let data of marketPlaceData">
                                                <div class="section">
                                                    <div class="list-items">
                                                        <div class="list-items-section" (click)="data['isOpen'] = !data['isOpen']">
                                                            <div class="cs-d-flex cursor-pointer" [ngClass]="{'open-folder-animation':data.isOpen }">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                                     viewBox="0 0 24 24" fill="none">
                                                                    <path
                                                                        d="M10.0001 19C9.7664 19.0005 9.53996 18.9191 9.36005 18.77C9.25879 18.6861 9.17509 18.5829 9.11374 18.4666C9.05239 18.3503 9.01459 18.2229 9.00251 18.092C8.99044 17.961 9.00432 17.8289 9.04337 17.7033C9.08241 17.5777 9.14585 17.461 9.23005 17.36L13.7101 12L9.39005 6.63C9.30699 6.52771 9.24495 6.41002 9.20752 6.28368C9.17009 6.15734 9.158 6.02485 9.17194 5.89382C9.18587 5.76279 9.22557 5.63581 9.28875 5.52017C9.35192 5.40453 9.43732 5.30252 9.54005 5.22C9.64352 5.12896 9.76468 5.0603 9.89595 5.01831C10.0272 4.97632 10.1657 4.96191 10.3028 4.976C10.4399 4.99008 10.5726 5.03235 10.6926 5.10016C10.8126 5.16796 10.9173 5.25983 11.0001 5.37L15.8301 11.37C15.9771 11.5489 16.0575 11.7734 16.0575 12.005C16.0575 12.2366 15.9771 12.4611 15.8301 12.64L10.8301 18.64C10.7297 18.761 10.6023 18.8567 10.4581 18.9192C10.3139 18.9818 10.157 19.0095 10.0001 19Z"
                                                                        fill="#979797" />
                                                                </svg>
                                                            </div>
                                                            <div *ngIf="!data.isOpen"><i class="fa fa-folder folder-icon" aria-hidden="true"></i></div>
                                                            <div *ngIf="data.isOpen"><i class="fa fa-folder-open folder-icon" aria-hidden="true"></i></div>
                                                            <div class="category-name"><span>{{ data.categoryName }}</span></div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="preview-section" *ngIf="data.isOpen">
                                                            <ng-container *ngFor="let image of data.certificates">
                                                                <div class="image-section">
                                                                    <img class="image-styles image-border" [src]="image.thumbnailUrl" (click)="addOption($event, image)">
                                                                    <div class="image-name">
                                                                        <span>{{image.name}}</span>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
					</div>
				</div>
                <div class="span12" *ngIf="showDefect">
                    <label class="control-label required_field" translate>Description</label>
                    <select csSelect2 [select2Config]="{width: '100%'}" tabindex="-1" formControlName="defectRecommendationList" (selected)="getSelectedDefect($event)">
                      <option value="" translate>Please.Choose</option>
                      <option *ngFor="let data of defectListData" [value]="data.id" [disabled]="data.isFreemium === 0 && freemiumAccess">
                        {{ data.description }}
                      </option>
                    </select>
                </div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<a href="javascript:void(0)" class="btn" (click)="bsModalRef.hide()" translate>Cancel</a>
		<button type="button" [disabled]='action != "save" || !addonForm.valid || (addonType == "blank" && editorAddon && !blankOption && !addMarketPlaceOption)' class="btn btn-primary" (click)="save(addonType)">
			<span *ngIf='action == "save"' translate>Save</span>
			<span *ngIf='action != "save"' translate>Saving</span>
		</button>
	</div>
</form>
<form *ngIf="addonForm && isViewMode" [formGroup]="addonForm">
    <div class="modal-header">
        <h4 class="modal-title pull-left" translate>Customer display name</h4>
    </div>
    <div class="modal-body">
        <div class="body-content-section">
            <div class="row-fluid">
                <div class="span12">
                    <div class="control-group clearfix">
                        <label class="control-label" translate>Customer.displaying.name</label>
                        <div class="controls customer-margin">
                            <input readonly type="text" class="control-input" formControlName="customerOptionName">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <a href="javascript:void(0)" class="btn" (click)="bsModalRef.hide()" translate>Close</a>
    </div>
</form>
